const buildVersion = "24.1.16"
const buildId = "24.1.16-1b50202"

export { buildId, buildVersion }
